import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9200c04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-result" }
const _hoisted_2 = {
  key: 1,
  class: "search-result-body"
}
const _hoisted_3 = ["tabindex"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "search-result-mobile-menu" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingView = _resolveComponent("LoadingView")!
  const _component_TheSearchResultLeftColumn = _resolveComponent("TheSearchResultLeftColumn")!
  const _component_ModalSheetMobile = _resolveComponent("ModalSheetMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isProcessing)
      ? (_openBlock(), _createBlock(_component_LoadingView, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            id: "modal-focus-target",
            class: "search-result-side",
            tabindex: _ctx.showModal ? '0' : '-1'
          }, [
            _createVNode(_component_ModalSheetMobile, {
              show: _ctx.showModal,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false)),
              title: _ctx.component === 'TheSearchImageResultMain' ? _ctx.$t('parts.facetFiltering') : _ctx.$t('form.sorting'),
              id: "search-result-modal-sheet"
            }, {
              modal: _withCtx(() => [
                _hoisted_4,
                _createVNode(_component_TheSearchResultLeftColumn, {
                  isVisibleFilteringLabel: _ctx.component !== 'TheSearchImageResultMain',
                  collectionId: _ctx.collectionId
                }, null, 8, ["isVisibleFilteringLabel", "collectionId"])
              ]),
              _: 1
            }, 8, ["show", "title"])
          ], 8, _hoisted_3),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
            pageNo: _ctx.pageNo,
            collection: _ctx.collection,
            onShowModal: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = true)),
            onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = false)),
            class: "search-result-main"
          }, null, 8, ["pageNo", "collection"]))
        ]))
  ]))
}